module.exports = __webpack_public_path__ + "static/img/wxq.7bc3dd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcimages/wxq.png
// module id = siq4
// module chunks = 51